/* unplugin-vue-components disabled */import { render } from "./data-table.vue?vue&type=template&id=0fca1d2f&scoped=true"
import script from "./data-table.vue?vue&type=script&lang=js"
export * from "./data-table.vue?vue&type=script&lang=js"

import "./data-table.vue?vue&type=style&index=0&id=0fca1d2f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fca1d2f"],['__file',"src/components/data-table/data-table.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fca1d2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fca1d2f', __exports__)) {
    api.reload('0fca1d2f', __exports__)
  }
  
  module.hot.accept("./data-table.vue?vue&type=template&id=0fca1d2f&scoped=true", () => {
    api.rerender('0fca1d2f', render)
  })

}


export default __exports__